import React from 'react';

import { getFormatDateWithDaysAgo } from 'utilities/date';

import { getDisplayUserName } from '../utility';

import { answerPropTypes } from './propTypes';

import './ProductAnswerReplyToReplyCard.scss';

const ProductAnswerReplyToReplyCard = ({ reply }) => {

	const {
		text, user, dateCreated, isStaff
	} = reply;

	return (
		<div className="ProductAnswerReplyToReplyCard">
			<div className="ProductAnswerReplyToReplyCard__body">
				<div className="ProductAnswerReplyToReplyCard__text">
					<span dangerouslySetInnerHTML={{ __html: text }} />
				</div>
				<div className="ProductAnswerReplyToReplyCard__userContainer">
					<div className="ProductAnswerReplyToReplyCard__username">
						{getDisplayUserName(user)}
						{user?.badge && (
							<span className="ProductAnswerReplyToReplyCard__badge">
								{user.badge.text}
							</span>
						)}
						{!user.badge && isStaff && <span className="ProductAnswerReplyCard__badge">Staff</span>}
					</div>
					<div className="ProductAnswerReplyToReplyCard__dateCreated">
						{getFormatDateWithDaysAgo(dateCreated)}
					</div>
				</div>
			</div>
		</div>
	);

};

ProductAnswerReplyToReplyCard.propTypes = {
	reply: answerPropTypes
};

export default ProductAnswerReplyToReplyCard;
